import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "language-switcher" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_menu, null, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn, _mergeProps({
          "aria-label": "Zmień język",
          icon: "mdi mdi-google-translate",
          variant: "text"
        }, props), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.currentLangSymbol()), 1)
          ]),
          _: 2
        }, 1040)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('pl')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("PL")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_list_item, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('en')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("EN")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_list_item, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('de')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("DE")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_list_item, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeLanguage('uk')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("UK")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}